import { graphql } from '../__generated__/gql';

export const GET_FLOC_DETAILS = graphql(/* GraphQL */ `
  query FlocDetails($floc: String!, $asset: String!) {
    flocDetails(floc: $floc, asset: $asset) {
      floc
      flocExists
      flocDetails
    }
  }
`);
